import { useEffect } from "react";

export default function useArticleTheme() {
  // add the cream page body class
  useEffect(() => {
    document.body.classList.add("articleCream");
    return () => document.body.classList.remove("articleCream");
  }, []);

  // applying saved theme on mount
  useEffect(() => {
    const saved = localStorage.getItem("theme");
    if (saved) document.documentElement.setAttribute("data-theme", saved);
  }, []);

  // toggle function for the button
  const toggleTheme = () => {
    const root = document.documentElement;
    const next = root.getAttribute("data-theme") === "dark" ? "light" : "dark";
    root.setAttribute("data-theme", next);
    localStorage.setItem("theme", next);
  };

  return { toggleTheme };
}
